import {createSnackbar} from "../library/utility";
import { connect } from 'react-redux';
export function addSnackbar(options = {}) {
const payload=createSnackbar(options)

return (dispatch) => {
  setTimeout(function(){
    dispatch({
    payload: payload.id,
    type: 'REMOVE_SNACKBAR'
      });

  },4000)
    dispatch({
    payload: payload,
    type: 'ADD_SNACKBAR'
      });
  }

}

export function removeSnackbar(id) {

return (dispatch) => {
    dispatch({
    payload: id,
    type: 'REMOVE_SNACKBAR'
      });
  }
}
